/**
 * Runtime configuration — resolved from Vite environment variables.
 *
 * VITE_BASE_PATH: The context path the SPA is served under (e.g., "/statuscentral").
 *   - Used as prefix for all API calls so requests route through Kong correctly.
 *   - Used as BrowserRouter basename for client-side routing.
 *   - In local dev, leave empty ("") since Vite proxy handles /api → backend.
 */

const env = import.meta.env as Record<string, string | undefined>;

/** Context path prefix (e.g., "/statuscentral"). Empty in local dev. */
export const BASE_PATH: string = env.VITE_BASE_PATH ?? "";

/** Prefix for API calls. Same as BASE_PATH (Kong strips it before forwarding). */
export const API_BASE_URL: string =
  env.NEXT_PUBLIC_API_BASE_URL ?? env.VITE_API_BASE_URL ?? BASE_PATH;

/**
 * Resolve a path with the API base URL prefix.
 * @example apiUrl("/api/v1/status/") => "/statuscentral/api/v1/status/"
 */
export function apiUrl(path: string): string {
  if (path.startsWith("http")) return path;
  return `${API_BASE_URL}${path}`;
}

/**
 * Drop-in replacement for fetch() that prefixes /api/ paths with the base URL.
 * Use instead of bare fetch() for all API calls.
 */
export function apiFetch(input: string, init?: RequestInit): Promise<Response> {
  return fetch(apiUrl(input), init);
}
